import React, { Component } from "react";
import _ from "lodash";
import DatePicker from "react-datepicker";
import Select from "react-select";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";

class ItemEstimateQuantitiesInputs extends Component {
  state = {};

  render() {
    const {
      ieq_dateSearchType,
      ieq_dateFrom,
      ieq_dateTo,
      ieq_selectedItems,
      handleChange_ieq_dateSearchType,
      handleChange_ieq_dateFrom,
      handleChange_ieq_dateTo,
      handleChange_ieq_item,
      projItemList,
      disabled,
      ieq_selectedItemsSearchType,
      handleChange_ieq_selectedItemsSearchType,
    } = this.props;
    return (
      <>
        <div className="card mx-0 mb-2">
          <div className="card-body pb-2">
            <h5 className="mb-3 text-muted">Item Estimate Quantities</h5>
            <div className="form-row form-group">
              <div className="col-sm-3 my-auto">
                <div className="custom-control custom-radio date-toggle">
                  <input
                    type="radio"
                    name="allDates"
                    id="allDates"
                    checked={ieq_dateSearchType === "allDates"}
                    onChange={handleChange_ieq_dateSearchType}
                    className="custom-control-input"
                    disabled={disabled}
                  />
                  <label htmlFor="allDates" className="custom-control-label">
                    All dates
                  </label>
                </div>
              </div>
            </div>
            <div className="form-row form-group">
              <div className="col-sm-3 my-auto">
                <div className="custom-control custom-radio date-toggle">
                  <input
                    type="radio"
                    name="dateRange"
                    id="dateRange"
                    checked={ieq_dateSearchType === "dateRange"}
                    onChange={handleChange_ieq_dateSearchType}
                    className="custom-control-input"
                    disabled={disabled}
                  />
                  <label htmlFor="dateRange" className="custom-control-label">
                    Date range:
                  </label>
                </div>
              </div>
              <div className="col-sm-9">
                <div className="row mb-0 ml-0">
                  <label htmlFor="dateFrom" className="form-label mx-2 my-auto">
                    From:
                  </label>
                  <div className="col-4">
                    <DatePicker
                      customInput={<CustomDatePickerInput />}
                      name="dateFrom"
                      id="dateFrom"
                      selected={ieq_dateFrom}
                      onChange={(value) => handleChange_ieq_dateFrom(value)}
                      disabled={disabled || ieq_dateSearchType !== "dateRange"}
                    />
                  </div>
                  <label htmlFor="dateTo" className="form-label mx-2 my-auto">
                    To:
                  </label>
                  <div className="col-4">
                    <DatePicker
                      customInput={<CustomDatePickerInput />}
                      name="dateTo"
                      id="dateTo"
                      selected={ieq_dateTo}
                      onChange={(value) => handleChange_ieq_dateTo(value)}
                      disabled={disabled || ieq_dateSearchType !== "dateRange"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card mx-0 mb-2">
          <div className="card-body pb-2">
            <div className="form-row form-group">
              <div className="col-sm-3 my-auto">
                <div className="custom-control custom-radio date-toggle">
                  <input
                    type="radio"
                    name="allItems"
                    id="allItems"
                    checked={ieq_selectedItemsSearchType === "allItems"}
                    onChange={handleChange_ieq_selectedItemsSearchType}
                    className="custom-control-input"
                    disabled={disabled}
                  />
                  <label htmlFor="allItems" className="custom-control-label">
                    All Items
                  </label>
                </div>
              </div>
            </div>
            <div className="form-row form-group">
              <div className="col-sm-3 my-auto">
                <div className="custom-control custom-radio date-toggle">
                  <input
                    type="radio"
                    name="selectedItems"
                    id="selectedItems"
                    checked={ieq_selectedItemsSearchType === "selectedItems"}
                    onChange={handleChange_ieq_selectedItemsSearchType}
                    className="custom-control-input"
                    disabled={disabled}
                  />
                  <label
                    htmlFor="selectedItems"
                    className="custom-control-label"
                  >
                    Items:
                  </label>
                </div>
              </div>
              <div className="col-sm-9 my-auto">
                <Select
                  name="itemIds"
                  id="itemIds"
                  isMulti={true}
                  value={ieq_selectedItems}
                  options={
                    projItemList &&
                    _.orderBy(
                      projItemList.map((i) => ({
                        value: i.bidItemId,
                        label: i.itemListCaption,
                        itemNo: i.itemNo,
                      })),
                      "itemNo",
                      "asc"
                    )
                  }
                  onChange={(value, context) =>
                    handleChange_ieq_item(value, context)
                  }
                  placeholderText="(Select or Key-in an Item)"
                  isSearchable
                  isDisabled={
                    disabled || ieq_selectedItemsSearchType !== "selectedItems"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ItemEstimateQuantitiesInputs;
